module.exports = __webpack_public_path__ + "img/member.b5a3ef22.png";